import MatchRoad from '@Components/MatchComponents/MatchRoad'
import React from 'react'

const MatchWorkSelectionHeader = () => (
    <>
        <p>In this step, you will locate the work you&apos;d like to match with your selected sound recording(s).</p>
        <p>
            Two criteria are required to search. If you do not have The MLC Song Code, click the down arrow to select
            another search criteria.
        </p>
        <p>
            To expand full details for the work, click the blue plus sign (<strong>+</strong>). To select a work, click
            <strong> Select.</strong>
        </p>
        <MatchRoad step={1} />
    </>
)

export default MatchWorkSelectionHeader
